import { JYOTISHA_TOPIC_SEARCH_INDEX } from '../data/jyotishaTopicSearchIndex';

function fold(text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** @type {{ en: string; hi: string; rank?: number }[]} */
const CURATED = [
  { en: 'What is kendradhipati dosha?', hi: 'केंद्राधिपति दोष क्या है?', rank: 120 },
  { en: 'What are Kendra houses (1, 4, 7, 10)?', hi: 'केंद्र भाव (1, 4, 7, 10) क्या हैं?', rank: 115 },
  { en: 'What is Kendra in Vedic astrology?', hi: 'वैदिक ज्योतिष में केंद्र क्या है?', rank: 110 },
  { en: 'What is the difference between Kendra and Trikona?', hi: 'केंद्र और त्रिकोण में क्या अंतर है?', rank: 108 },
  { en: 'What is Gochar (transit)?', hi: 'गोचर क्या है?', rank: 100 },
  { en: 'What is Sade Sati?', hi: 'साढ़े साती क्या है?', rank: 100 },
  { en: 'What is Navamsa (D9)?', hi: 'नवांश (D9) क्या है?', rank: 98 },
  { en: 'What is neech bhanga (debilitation cancellation)?', hi: 'नीच भंग क्या है?', rank: 96 },
  { en: 'What is Kemadruma yoga?', hi: 'केमद्रुम योग क्या है?', rank: 94 },
  { en: 'What is Manglik dosha?', hi: 'मांगलिक दोष क्या है?', rank: 94 },
  { en: 'What is Kaal Sarp dosha?', hi: 'काल सर्प दोष क्या है?', rank: 92 },
  { en: 'What is functional benefic and malefic?', hi: 'कार्यात्मक शुभ और अशुभ क्या है?', rank: 90 },
  { en: 'How do I read the 7th house?', hi: 'सातवाँ भाव कैसे पढ़ें?', rank: 88 },
  { en: 'How do I read the 10th house for career?', hi: 'करियर के लिए दसवाँ भाव कैसे पढ़ें?', rank: 86 },
  { en: 'What is Lagna (ascendant)?', hi: 'लग्न (उदय) क्या है?', rank: 85 },
  { en: 'Difference between Lagna and Moon sign?', hi: 'लग्न और चंद्र राशि में अंतर?', rank: 84 },
  { en: 'What is Vimshottari dasha?', hi: 'विंशोत्तरी दशा क्या है?', rank: 82 },
  { en: 'What is Mahadasha and Antardasha?', hi: 'महादशा और अंतरदशा क्या है?', rank: 80 },
  { en: 'What is a house lord (bhavesh)?', hi: 'भावेश (भाव स्वामी) क्या है?', rank: 78 },
  { en: 'What happens when 7th lord is in 8th house?', hi: 'जब सातवें भाव का स्वामी आठवें भाव में हो?', rank: 76 },
  { en: 'What is drishti (aspect) in Jyotisha?', hi: 'ज्योतिष में दृष्टि क्या है?', rank: 74 },
  { en: 'What is retrograde (vakri) planet?', hi: 'वक्री ग्रह क्या है?', rank: 72 },
  { en: 'What is exaltation and debilitation?', hi: 'उच्च और नीच क्या है?', rank: 70 },
  { en: 'What is Panchang?', hi: 'पंचांग क्या है?', rank: 68 },
  { en: 'What is muhurta?', hi: 'मुहूर्त क्या है?', rank: 66 },
  { en: 'What is nakshatra?', hi: 'नक्षत्र क्या है?', rank: 64 },
  { en: 'What is Rashi (zodiac sign)?', hi: 'राशि क्या है?', rank: 62 },
  { en: 'What is varga / divisional chart?', hi: 'वर्ग / विभाजन कुंडली क्या है?', rank: 60 },
  { en: 'What is Raj yoga?', hi: 'राज योग क्या है?', rank: 58 },
  { en: 'What is dusthana (6, 8, 12)?', hi: 'दुष्टस्थान (6, 8, 12) क्या है?', rank: 56 },
  { en: 'What is maraka house?', hi: 'मारक भाव क्या है?', rank: 54 },
  { en: 'What is yogakaraka planet?', hi: 'योगकारक ग्रह क्या है?', rank: 52 },
  { en: 'What is Ayanamsa?', hi: 'अयनांश क्या है?', rank: 50 },
  { en: 'What is sidereal vs tropical zodiac?', hi: 'नक्षत्रीय बनाम उष्णकटिबंधीय राशि?', rank: 48 },
];

/** @type {Map<string, { en: string; hi: string; rank: number }>} */
let corpusByKey = null;

function corpusKey(en) {
  return fold(en);
}

function buildCorpus() {
  if (corpusByKey) return corpusByKey;
  corpusByKey = new Map();

  const add = (en, hi, rank = 40) => {
    const key = corpusKey(en);
    if (!key || key.length < 4) return;
    const existing = corpusByKey.get(key);
    if (!existing || (existing.rank ?? 0) < rank) {
      corpusByKey.set(key, { en, hi, rank });
    }
  };

  CURATED.forEach((c) => add(c.en, c.hi, c.rank ?? 50));

  for (const entry of JYOTISHA_TOPIC_SEARCH_INDEX) {
    const label = entry.tabLabel?.trim();
    if (!label || label.length < 3 || label.length > 72) continue;
    if (/^[\d.]/.test(label)) continue;
    add(`What is ${label}?`, `${label} क्या है?`, 35);
    add(`Explain ${label} in Jyotisha`, `ज्योतिष में ${label} समझाएँ`, 28);
  }

  const termQuestions = [
    ['kendradhipati', 'What is kendradhipati dosha?', 'केंद्राधिपति दोष क्या है?'],
    ['kendra', 'What are Kendra houses?', 'केंद्र भाव क्या हैं?'],
    ['trikona', 'What are Trikona houses?', 'त्रिकोण भाव क्या हैं?'],
    ['upachaya', 'What are Upachaya houses?', 'उपचय भाव क्या हैं?'],
    ['ashtakavarga', 'What is Ashtakavarga?', 'अष्टकवर्ग क्या है?'],
    ['shadbala', 'What is Shadbala?', 'षड्बल क्या है?'],
    ['bhavat bhavam', 'What is bhavat bhavam?', 'भावात् भावम् क्या है?'],
    ['chara karaka', 'What are Chara Karakas?', 'चर कारक क्या हैं?'],
    ['atmakaraka', 'What is Atmakaraka?', 'आत्मकारक क्या है?'],
    ['daridra', 'What is Daridra yoga?', 'दरिद्र योग क्या है?'],
    ['vipreet', 'What is Vipreet Raj yoga?', 'विपरीत राज योग क्या है?'],
    ['gajakesari', 'What is Gajakesari yoga?', 'गजकेसरी योग क्या है?'],
    ['panch mahapurush', 'What is Panch Mahapurush yoga?', 'पंच महापुरुष योग क्या है?'],
    ['gandanta', 'What is Gandanta?', 'गंडांत क्या है?'],
    ['sandhi', 'What is dasha sandhi?', 'दशा संधि क्या है?'],
  ];

  for (const [term, en, hi] of termQuestions) {
    add(en, hi, 70);
    add(`What is ${term}?`, `${term} क्या है?`, 65);
  }

  return corpusByKey;
}

/**
 * @param {string} query
 * @param {{ showEnglish?: boolean; limit?: number }} [opts]
 * @returns {{ text: string; rank: number }[]}
 */
export function suggestAskGuruQueries(query, opts = {}) {
  const limit = opts.limit ?? 8;
  const showEnglish = opts.showEnglish !== false;
  const q = fold(query).trim();
  if (q.length < 2) return [];

  const corpus = buildCorpus();
  /** @type {{ text: string; rank: number }[]} */
  const scored = [];

  for (const item of corpus.values()) {
    const text = showEnglish ? item.en : item.hi;
    const f = fold(text);
    let rank = 0;

    if (f === q) rank = 1000 + (item.rank ?? 0);
    else if (f.startsWith(q)) rank = 500 + (item.rank ?? 0) + Math.max(0, 80 - text.length);
    else if (f.includes(q)) rank = 200 + (item.rank ?? 0);
    else {
      const words = q.split(/\s+/).filter((w) => w.length >= 2);
      if (words.length > 1 && words.every((w) => f.includes(w))) {
        rank = 120 + (item.rank ?? 0);
      }
    }

    if (rank > 0) scored.push({ text, rank });
  }

  scored.sort((a, b) => {
    if (b.rank !== a.rank) return b.rank - a.rank;
    return a.text.length - b.text.length;
  });

  const seen = new Set();
  const out = [];
  for (const row of scored) {
    const key = fold(row.text);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(row);
    if (out.length >= limit) break;
  }

  return out;
}

/**
 * Split suggestion for Google-style bold continuation.
 * @param {string} query
 * @param {string} suggestion
 */
export function splitQuerySuggestionHighlight(query, suggestion) {
  const q = query.trim();
  const fQ = fold(q);
  const fS = fold(suggestion);
  const idx = fS.indexOf(fQ);
  if (idx < 0) {
    return { matched: '', completion: suggestion };
  }
  const end = idx + q.length;
  return {
    matched: suggestion.slice(0, end),
    completion: suggestion.slice(end),
  };
}

export const BHRIGU_REFERRER_TOPIC_KEY = 'parashari_bhrigu_referrer_topic';
export const BHRIGU_REFERRER_SCHOOL_KEY = 'bhrigu_referrer_school';

/**
 * @param {{ school?: string; topicId?: string | null }} payload
 */
export function setBhriguReferrer({ school = 'parashari', topicId = null } = {}) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    if (topicId) {
      sessionStorage.setItem(BHRIGU_REFERRER_TOPIC_KEY, String(topicId));
    }
    sessionStorage.setItem(BHRIGU_REFERRER_SCHOOL_KEY, String(school || 'parashari'));
  } catch {
    /* ignore */
  }
}

/**
 * @returns {{ school: string | null; topicId: string | null }}
 */
export function readBhriguReferrer() {
  if (typeof sessionStorage === 'undefined') {
    return { school: null, topicId: null };
  }
  try {
    return {
      school: sessionStorage.getItem(BHRIGU_REFERRER_SCHOOL_KEY),
      topicId: sessionStorage.getItem(BHRIGU_REFERRER_TOPIC_KEY),
    };
  } catch {
    return { school: null, topicId: null };
  }
}

/**
 * @param {{ en: string; hi: string }[]} items
 */
function shuffleItems(items) {
  const out = [...items];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

/**
 * @param {{ en: string; hi: string; rank?: number }} item
 * @param {{ id: string; tabLabel?: string; groupLabel?: string; terms?: string }} topicEntry
 */
function scoreQuestionForTopic(item, topicEntry) {
  const topicText = fold([topicEntry.id, topicEntry.tabLabel, topicEntry.groupLabel, topicEntry.terms].join(' '));
  const topicWords = topicText.split(/\s+/).filter((w) => w.length >= 3);
  const qFold = fold(item.en);
  let score = 0;
  for (const w of topicWords) {
    if (qFold.includes(w)) score += 12;
  }
  return score + (item.rank ?? 0) * 0.05;
}

/**
 * Starter chips for idle AskGuru - contextual to chapter or random defaults.
 * @param {{ topicId?: string | null; showEnglish?: boolean; limit?: number }} [opts]
 * @returns {{ en: string; hi: string }[]}
 */
export function getBhriguStarterPrompts(opts = {}) {
  const { topicId = null, limit = 5 } = opts;
  const corpus = [...buildCorpus().values()];

  if (topicId) {
    const topicEntry = JYOTISHA_TOPIC_SEARCH_INDEX.find((e) => e.id === topicId);
    if (topicEntry) {
      const scored = corpus
        .map((item) => ({ item, score: scoreQuestionForTopic(item, topicEntry) }))
        .filter((row) => row.score > 8)
        .sort((a, b) => b.score - a.score);

      const matched = scored.map((row) => row.item);
      const matchedKeys = new Set(matched.map((m) => corpusKey(m.en)));
      const filler = shuffleItems(corpus.filter((c) => !matchedKeys.has(corpusKey(c.en))));

      const pool = [...matched, ...filler];
      return shuffleItems(pool)
        .slice(0, limit)
        .map((p) => ({ en: p.en, hi: p.hi }));
    }
  }

  return shuffleItems(CURATED)
    .slice(0, limit)
    .map((p) => ({ en: p.en, hi: p.hi }));
}
